import { render, staticRenderFns } from "./AccessPoints.vue?vue&type=template&id=91afda6a&"
import script from "./AccessPoints.vue?vue&type=script&lang=ts&"
export * from "./AccessPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports